// Logos that need 2x sizing
const largerLogos = [
  "ahocon.com.png",
  "bpsnh.com.png",
  "petersenbuilthomes.com.png",
  "raisanenhomes.com.png",
  "schroedercmi.com.png",
  "tcdbuild.com.png",
  "woodcastlehomes.net.png",
];

const partnerLogos = [
  { src: "/images/logos/ahocon.com.png", name: "Ahocon", url: "https://ahocon.com", w: 337, h: 337 },
  { src: "/images/logos/apwhitaker.com.png", name: "AP Whitaker", url: "https://apwhitaker.com", w: 1024, h: 300 },
  { src: "/images/logos/bosquetbuilders.com.png", name: "Bosquet Builders", url: "https://bosquetbuilders.com", w: 337, h: 180 },
  { src: "/images/logos/bpsnh.com.png", name: "BPS NH", url: "https://bpsnh.com", w: 337, h: 337 },
  { src: "/images/logos/eckmanconstruction.com.png", name: "Eckman Construction", url: "https://eckmanconstruction.com", w: 331, h: 82 },
  { src: "/images/logos/facebook.com_skyviewcommunity.jpg", name: "Skyview Community", url: "#", w: 331, h: 120 },
  { src: "/images/logos/ferrisdevelopment.com.png", name: "Ferris Development", url: "https://ferrisdevelopment.com", w: 1500, h: 250 },
  { src: "/images/logos/flynnconstructioncorp.com.jpg", name: "Flynn Construction Corp", url: "https://flynnconstructioncorp.com", w: 331, h: 49 },
  { src: "/images/logos/petersenbuilthomes.com.png", name: "Petersen Built Homes", url: "https://petersenbuilthomes.com", w: 337, h: 251 },
  { src: "/images/logos/raisanenhomes.com.png", name: "Raisanen Homes", url: "https://raisanenhomes.com", w: 337, h: 337 },
  { src: "/images/logos/reescustomhomes.com.png", name: "Rees Custom Homes", url: "https://reescustomhomes.com", w: 709, h: 600 },
  { src: "/images/logos/schroedercmi.com.png", name: "Schroeder CMI", url: "https://schroedercmi.com", w: 460, h: 460 },
  { src: "/images/logos/tcdbuild.com.png", name: "TCD Build", url: "https://tcdbuild.com", w: 337, h: 337 },
  { src: "/images/logos/woodcastlehomes.net.png", name: "Woodcastle Homes", url: "https://woodcastlehomes.net", w: 337, h: 337 },
];

const TrustedPartners = () => {
  return (
    <section className="py-16 md:py-20 bg-secondary">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="section-heading">Trusted Partners</h2>
          <p className="section-subheading mx-auto">
            Proud to work alongside New Hampshire's finest builders and contractors.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 md:gap-8">
          {partnerLogos.map((partner) => {
            const isDeadLink = partner.url === "#";
            const filename = partner.src.split('/').pop() || '';
            const isLarger = largerLogos.includes(filename);
            
            return (
              <a
                key={partner.name}
                href={partner.url}
                target={isDeadLink ? undefined : "_blank"}
                rel={isDeadLink ? undefined : "noopener noreferrer"}
                className={`
                  flex items-center justify-center p-4 bg-background rounded-lg
                  transition-all duration-300
                  ${isDeadLink 
                    ? "cursor-default" 
                    : "hover:shadow-lg hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                  }
                `}
                onClick={isDeadLink ? (e) => e.preventDefault() : undefined}
                aria-label={isDeadLink ? partner.name : `Visit ${partner.name} website`}
              >
                <picture>
                  <source srcSet={partner.src.replace(/\.(jpe?g|png)$/i, ".webp")} type="image/webp" />
                  <img
                    src={partner.src}
                    alt={`${partner.name} partner logo`}
                    loading="lazy"
                    decoding="async"
                    width={partner.w}
                    height={partner.h}
                    className={`
                      w-auto max-w-full object-contain
                      transition-all duration-300
                      ${isLarger ? "h-32 md:h-40" : "h-16 md:h-20"}
                      ${isDeadLink ? "grayscale opacity-60" : "grayscale hover:grayscale-0"}
                    `}
                  />
                </picture>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustedPartners;
